import { cn, tv, VariantProps } from '@utils';

import { Render } from '@components/Shared';
import { Logo } from '@components/Ui';

const variants = tv({
  base: 'flex items-center shrink-0 justify-center border border-neural-02 overflow-hidden rounded-lg bg-white',
  variants: {
    size: {
      lg: 'h-28 w-28',
      md: 'h-14 w-14',
      sm: 'h-12 w-12',
      xs: 'h-8 w-8',
    },
    placeholder: {
      true: 'p-2',
    },
  },
  defaultVariants: {
    size: 'sm',
  },
});

type Props = VariantProps<typeof variants> & {
  className?: string;
  color?: boolean;
  src?: string;
};

export const PlatformAppLogo: React.FC<Props> = ({
  className,
  color = false,
  src,
  size,
}) => {
  const withDefaultLogo = !src;

  return (
    <div
      className={cn(
        variants({ size, placeholder: withDefaultLogo }),
        className,
      )}
    >
      <Render if={src}>
        <img src={src} alt="" />
      </Render>
      <Render if={!src}>
        <Logo.Icon color={color} className="text-black" />
      </Render>
    </div>
  );
};
